export const version = "signing-key/5.0.5";
//# sourceMappingURL=_version.js.map